import { render, staticRenderFns } from "./LabelSelectDialog.vue?vue&type=template&id=d68b6ace"
import script from "./LabelSelectDialog.vue?vue&type=script&lang=js"
export * from "./LabelSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports